import $ from 'jquery';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import { $Elements, Animations, BrowserEvents, Classes, Elements } from '../global/constants';

gsap.registerPlugin(ScrollTrigger);

// ---------- Init Scroll Animation ----------

export const initScrollAnimations = () => {

	// ---------- Variables ----------

	$Elements.HeaderWrapper.each(function() {

		Animations.global.push(() => {

			const timeline = gsap.timeline({
				scrollTrigger: {
					trigger: Elements.PageWrapper,
					start: this.offsetHeight / 2,
					toggleClass: {
						targets: this,
						className: Classes.menuLight
					},
				}
			});
		});
	});

	// ---------- Animated Section ----------

	$('.animated-section:not(.transition-clone)').each(function() {

		Animations.global.push(() => {

			const timeline = gsap.timeline({
				scrollTrigger: {
					trigger: this,
					once: true,
					start: 'top 80%',
					toggleClass: Classes.active,
				}
			});
		});
	});

	// ---------- Content Sections ----------

	$('.parallax-section:not(.fixed-parallax-section):not(.transition-clone)').each(function() {

		Animations.mobile.min.push(() => {

			const image = this.querySelector(':scope .section-image');
			const speed = 25;

			if(image) {

				const timeline = gsap.timeline({
					scrollTrigger: {
						trigger: this,
						start: 'top bottom',
						end: 'bottom top',
						scrub: true,
					},
				});

				timeline.fromTo(image, { yPercent: -speed }, { yPercent: speed, ease: 'none' });
			}
		});
	});

	// ---------- parallax-text-image-section ----------

	$('.parallax-text-image-section:not(.fixed-parallax-section):not(.transition-clone)').each(function() {

		Animations.global.push(() => {

			const image = this.querySelector(':scope .animated-text');
			const speed = 25;

			if(image) {

				const timeline = gsap.timeline({
					scrollTrigger: {
						trigger: this,
						start: 'top bottom',
						end: 'bottom top',
						scrub: true,
					},
				});

				timeline.fromTo(image, { xPercent: 10 }, { xPercent: -speed * 2, ease: 'none' });
			}
		});
	});


	$('.all-ranges-section').each(function() {

		Animations.mobile.min.push(() => {

			const image = this.querySelector(':scope .packshot-column .column-image');

			if(image) {

				const timeline = gsap.timeline({
					scrollTrigger: {
						trigger: this,
						start: 'top bottom',
						end: 'bottom top',
						scrub: true,
						invalidateOnRefresh: true,
					},
				});

				timeline.fromTo(image, {
					y: () => (this.classList.contains('right-image')) || (this.classList.contains('frizzata-section')) ? -300 : +400
				}, {
					y: () => (this.classList.contains('right-image')) || (this.classList.contains('frizzata-section')) ?
						this.clientHeight - image.clientHeight - 700 : this.clientHeight - image.clientHeight - 300
				});
			}
		});
	});
};

$Elements.document.on(BrowserEvents.page.enter, () => initScrollAnimations());
